<ion-app>
  @if (appReady) {
    @if (isLoggedIn && subtitle !== 'Home') {
      <ion-menu contentId="main-content" id="menuHamburger">
        <ion-header>
          <ion-toolbar>
            <ion-title>Índice</ion-title>
          </ion-toolbar>
        </ion-header>

        <ion-content>
          @if (!showSubMenu) {
            <ion-list>
              <ion-list-header>
                <ion-label class="label">Departamentos</ion-label>
              </ion-list-header>
              @for (dept of departments; track dept) {
                <ion-item button (click)="showDepartmentSubMenu(dept)">
                  <ion-label>{{ dept }}</ion-label>
                  <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
                </ion-item>
              }
            </ion-list>
          } @else {
            <ion-list>
              <ion-item button (click)="backToMainMenu()">
                <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
                <ion-label><strong>{{ selectedDepartment }}</strong></ion-label>
              </ion-item>
              <hr>

              @for (card of cardsForSubMenu; track card.title) {
                <ion-menu-toggle>
                  <ion-item [routerLink]="card.link" 
                            [disabled]="card.extraClass === 'noLink'" 
                            [button]="card.extraClass !== 'noLink'">
                    <ion-label>{{ card.title }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>

                @if (getButtonsForCard(card.title).length > 0) {
                  @for (button of getButtonsForCard(card.title); track button.link) {
                    <ion-menu-toggle>
                      <ion-item (click)="goToLink(button.link)" button class="sub-item">
                        <ion-icon slot="start" name="open-outline"></ion-icon>
                        <ion-label>{{ button.text }}</ion-label>
                      </ion-item>
                    </ion-menu-toggle>
                  }
                }
              } @empty {
                <ion-item lines="none">
                  <ion-label class="ion-text-wrap ion-padding-start">
                    No hay herramientas disponibles por el momento...
                  </ion-label>
                </ion-item>
              }
            </ion-list>
          }
        </ion-content>

        <ion-footer>
          <ion-toolbar>
            <ion-item button class="logoutButton" (click)="logout()">
              <ion-label class="ion-text-center">Cerrar sesión</ion-label>
            </ion-item>
          </ion-toolbar>
        </ion-footer>
      </ion-menu>
    }

    <div class="ion-page" id="main-content">
      @if (subtitle !== 'Home') {
        <ion-header>
          <ion-toolbar>
            <ion-menu-button slot="start" autoHide="true" class="menuButton"></ion-menu-button>
            <ion-title>
              <a [routerLink]="['/Home']" draggable="false" class="title-link">
                <img src="/assets/images/geddis_logo.webp" alt="Logo de geddiss" height="46" width="150px" loading="eager" id="logoGeddis">
                <span class="subtitle">{{ subtitle }}</span>
              </a>
            </ion-title>
            <ion-buttons slot="end" class="logoContainer">
              <a draggable="false" href="https://www.geopost.com">
                <img height="34px" width="60px" src="/assets/images/geoLogo.webp" alt="Geopost logo" loading="eager" class="logoImage"/>
              </a>
              <a draggable="false" href="https://www.seur.com/es/">
                <img src="/assets/images/SEUR_logo.webp" height="15px" width="103px" alt="Seur Logo" loading="eager" class="logoImage"/>
              </a>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
      }

      <ion-content>
        <router-outlet class="mainBody" (activate)="onActivate($event)"></router-outlet>
        <ng-template #loginMessage>
          <h2>Debes iniciar sesión <a href="https://seurconecta.seur.es/">aquí</a> para poder acceder.</h2>
        </ng-template>
      </ion-content>

      @if (subtitle === 'Login') {
        <ion-footer collapse="fade" class="footer">
          <ion-label class="labelFooter">&copy; 2025 GEDDIS, Geopost España S.L.</ion-label>
        </ion-footer>
      }
    </div>
  }
</ion-app>